var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContractServiceBody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 254,
    viewBox: "0 0 238 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.138 196.559L148.931 222.914L72.5555 252.497L20.9214 222.915L102.138 196.559Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8179 81.0898C60.6413 81.0898 45.7234 92.9109 41.7974 109.633L25.2234 180.226C22.2765 192.777 31.8009 204.797 44.6939 204.797H122.678L131.867 226.849L194.137 204.72C206.367 203.655 214.937 191.72 211.667 179.591L191.097 103.282C187.567 90.1876 175.692 81.0898 162.131 81.0898H77.8179Z",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0981 42.656C79.2746 30.5595 88.6414 19.6748 100.875 19.6748H137.06C149.285 19.6748 158.649 30.5453 156.84 42.6354L151.118 80.864C150.018 88.2089 143.71 93.6436 136.283 93.6436H101.693C94.2717 93.6436 87.9663 88.2174 86.8601 80.8795L81.0981 42.656Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.138 190.105L125.535 203.283L135.094 220.395L72.5555 246.043L20.9214 216.461L102.138 190.105Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.868 224.135L125.458 203.702L92.0982 206.88C90.6855 207.015 89.9014 208.582 90.6408 209.793C91.903 211.861 94.1803 213.09 96.6017 213.01L111.071 212.532L109.86 214.199C108.788 215.676 107.365 216.862 105.72 217.652L85.5534 227.336C83.1285 228.5 82.5211 231.678 84.3456 233.655L87.1135 236.654C91.2703 241.157 97.2623 243.506 103.372 243.027L110.301 242.484C115.095 242.109 119.666 240.301 123.421 237.296L139.868 224.135Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.339 78.6022C107.713 78.4654 108.938 79.4683 109.075 80.8422L109.618 86.2964C109.755 87.6703 108.752 88.895 107.378 89.0318C106.004 89.1686 104.779 88.1657 104.643 86.7918L104.099 81.3376C103.963 79.9637 104.966 78.739 106.339 78.6022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.12 78.6022C130.746 78.4654 129.521 79.4683 129.384 80.8422L128.841 86.2964C128.704 87.6703 129.707 88.895 131.081 89.0318C132.455 89.1686 133.68 88.1657 133.816 86.7918L134.36 81.3376C134.496 79.9637 133.493 78.739 132.12 78.6022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3846 97.5532C67.7538 88.0667 42.9487 83.8983 32 83C44.0615 95.9362 60.359 134.745 67 152.532L109 159L79.3846 97.5532Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 92.8796C38.7829 100.215 43.08 126.322 50.0629 139.267L58.12 159.224L107 163L76.3829 99.892C58.12 92.3405 29.4724 90.7221 13 92.8796Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0531 151.307L73.2897 155.869C70.2698 160.855 64.8471 164.111 59.1444 162.905C56.4758 162.34 53.6103 161.45 51.0998 160.047C46.678 157.576 43.9749 151.365 43.1455 149.38L35.0383 127.667C34.0985 125.15 35.491 122.513 38.1047 123.135C38.2835 123.177 38.4658 123.225 38.6513 123.278C42.6243 124.416 48.8672 133.777 50.168 138.285L61.5808 124.245C63.7326 121.598 67.8451 121.835 69.6779 124.712L75.8627 134.422C79.1329 139.556 79.2067 146.101 76.0531 151.307Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.875 19.6748C88.6415 19.6748 79.2747 30.5595 81.0982 42.656L86.551 78.8285L132.881 65.4747L152.246 73.3291L156.84 42.6354C158.649 30.5453 149.285 19.6748 137.06 19.6748H100.875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 254,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractServiceBody);
export default __webpack_public_path__ + "static/media/IcContractServiceBody.d6933151b2a3c61d1219a84dc48c4c4d.svg";
export { ForwardRef as ReactComponent };